import actions from './zones.actions'
import getters from './zones.getters'
import mutations from './zones.mutations'
import state from './zones.state'

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
